import * as React from 'react';
import classNames from 'classnames';

import type { Without } from '@/types/generic';

type HtmlButtonProps =
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export type SubmitterProps = {
  label: string;
  handlePress: (
    event: Parameters<HtmlButtonProps['onClick']>[0]|Parameters<HtmlButtonProps['onKeyPress']>[0]
  ) => void;
} & Without<HtmlButtonProps, 'ref', 'onClick', 'onKeyPress'>;

interface SubmitterState {
  status?: 'submitting'|'done'|'error';
}

export class Submitter extends React.Component<SubmitterProps, SubmitterState> {
  constructor(props) {
    super(props);
    this.state = { status: null };
  }

  setStatus(status: SubmitterState['status']) {
    this.setState({ status });
    if (status === 'submitting') return;
    setTimeout(() => this.setState({ status: null }), 1000);
  }

  render() {
    const { label, handlePress, ...buttonProps } = this.props;
    const { status } = this.state;
    return (
      <button
        type="button"
        className={classNames('submitter', 'ui-link', status)}
        onClick={handlePress}
        onKeyPress={handlePress}
        {...buttonProps} // eslint-disable-line react/jsx-props-no-spreading
      >
        {label}
      </button>
    );
  }
}
